<template>
  <div class="w-100">
    <header class="py35 pl20" v-if="!offersLoading">
      <div class="container">
        <div class="links">
          <div class="semi-link" @click="handleBack" v-if="previousQuestion">
            Back
          </div>
          <div class="restart-link" :class="{'-full' : !previousQuestion}" @click="handleRestart">
            Restart
          </div>
        </div>
        <!--<div class="row middle-sm center-xs cl-primary">
          <h2 class="col-sm-9 mb10">
            Thank you for completing your Style ID!
          </h2>
          <h4 v-if="variants.length">Here are some ({{ variants.length }}) auto-generated designs based on your answers. Let us know if you like any</h4>
          <div v-else>
            <h4>Thank you for completing your style ID questionnaire! We will process your information and contact you with the list of designs created just for you. Please register below to receive your designs.</h4>
            <button-outline @click="invitation" color="dark">
              Register
            </button-outline>
          </div>
        </div>-->
      </div>
    </header>
    <div v-if="offersLoading" class="container">
      <div class="row middle-sm center-xs cl-primary">
        <div class="col-sm-9">
          <h3>Please wait while we custom design your collections...</h3>

          <img src="../../../assets/loading.svg" alt="">
        </div>
      </div>
    </div>
    <div class="container pb60" v-if="!variants.length">
      <div class="row brdr-top-1 brdr-bottom-1 brdr-cl-secondary">
        <div>
          <h4>Thank you for completing your style ID questionnaire! We will process your information and contact you with the list of designs created just for you.</h4>
        </div>
      </div>
    </div>
    <div class="container pb60" v-if="variants.length">
      <div class="row brdr-top-1 brdr-bottom-1 brdr-cl-secondary">
        <div class="col-xs-6 flex flex-a-c">
          <span>
            {{ userName ? `${userName}'s` : 'our' | capitalize }} Exclusive Designs
          </span>
        </div>
        <div class="col-xs-6 right">
          <paginate
            v-if="totalPages"
            v-model="currentPage"
            :page-count="totalPages"
            :container-class="'pagination'"
          />
        </div>
      </div>
      <div class="row m0 pt15 questionnaire-end">
        <div class="col-xs-12 col-md-10 col-md-offset-1 center-xs">
          <offer v-for="variant in currentPageVariants" :key="variant.id"
                 :variant="variant" :model="offers.model" :model-back="offers.modelBack" @cart-add="handleAddToCart(variant)"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 center-xs">
          <paginate
            v-if="totalPages"
            v-model="currentPage"
            :page-count="totalPages"
            :container-class="'pagination'"
            :prev-text="'Prev'"
            :next-text="'Next'"
          />
        </div>
      </div>
      <continue-button @click="handleRestart">I don't like what I see, start over</continue-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import Paginate from 'vuejs-paginate'
import store from '../../../store'
import Offer from './Offers/Offer'
import invitationButton from '../../../mixins/invitationButton'
import {nameHexColor} from '../../../services/color'
import {encodeSKU} from '../../../services/toDataURL'
import ContinueButton from './Fields/ContinueButton'

export default {
  name: 'Offers',
  mixins: [invitationButton],
  data () {
    return {
      agreed: true,
      authToken: '',
      pageCount: 20,
      currentPage: 1,
      dropInInstance: null,
      paymentIsValid: false,
      patternData: {},
      errors: [],
      layerOrder: [
        'Model',
        'Top',
        ['Skirt', 'Pants'],
        'Sleeve',
        ['', 'Belt', 'Embroidery']
      ],
      flatLayerOrder: [
        'Model',
        'Skirt',
        'Pants',
        'Sleeve',
        'Top',
        'Belt',
        'Embroidery'
      ],
      moodPictures: {
        'The Minimalist': '/questionnaire/mood_boards/the_minimalist.jpg',
        'Bell Sleeves': '/questionnaire/mood_boards/bell_sleeves.jpg',
        'Flutter Sleeves': '/questionnaire/mood_boards/flutter_sleeves.jpg',
        'Pretty Woman': '/questionnaire/mood_boards/pretty_woman.jpg',
        'Poetic Sleeves': '/questionnaire/mood_boards/poetic_sleeves.jpg',
        'Overskirt': '/questionnaire/mood_boards/overskirt_train.jpg',
        'Dramatic Sleeves': '/questionnaire/mood_boards/dramatic_sleeves.jpg',
        'The Cape': '/questionnaire/mood_boards/the_cape.jpg',
        'Asymmetrical ': '/questionnaire/mood_boards/asymmetrical_wedding.jpg',
        'Dramatic Back Train': '/questionnaire/mood_boards/dramatic_back.jpg',
        'Creme Brule': '/questionnaire/mood_boards/creme_brulee.jpg',
        'Bridal Trouser': '/questionnaire/mood_boards/bridal_trouser.jpg',
        'Leg Action': '/questionnaire/mood_boards/leg_action.jpg',
        'Décolleté': '/questionnaire/mood_boards/decollete_wedding.jpg',
        'Cold Shoulder': '/questionnaire/mood_boards/cold_shoulder.jpg',
        'Halter Neck': '/questionnaire/mood_boards/halter_neck.jpg',
        'Open Back': '/questionnaire/mood_boards/open_back.jpg',
        'Floral Applique': '/questionnaire/mood_boards/floral_applique.jpg',
        'Lace': '/questionnaire/mood_boards/lace_wedding.jpg',
        'Modern Princess': '/questionnaire/mood_boards/modern_princess_wedding.jpg'
      }
    }
  },
  components: {
    ContinueButton,
    Offer,
    Paginate
  },
  beforeRouteEnter (to, from, next) {
    if (!store.getters['user/isLoggedIn']) {
      next(new Error('Unauthorized'))
    } else {
      next()
    }
  },
  computed: {
    ...mapGetters('questionnaire', [
      'question',
      'results',
      'previousQuestion',
      'offers',
      'offersLoading',
      'fittingItems',
      'paintColors',
      'answerByQuestionName'
    ]),
    // ...mapGetters('user', ['isLoggedIn']),
    canSubmit () {
      return this.paymentIsValid && this.agreed
    },
    userName () {
      return this.$store.state.user.current.firstname
    },
    firstQuestionAnswer () {
      const answer = this.answerByQuestionName('question_1')
      return answer.value || answer
    },
    currentPageVariants () {
      if (this.variants && this.variants.length) {
        return this.variants.slice((this.currentPage - 1) * this.pageCount, this.currentPage * this.pageCount)
      }
      return []
    },
    totalPages () {
      return this.variants && this.variants.length ? Math.ceil(this.variants.length / this.pageCount) : 0
    },
    variants () {
      if (this.fittingItems && Object.keys(this.fittingItems).length) {
        // take first by layer order, combine with others
        const combinedItems = this.combineItems([], [{}])
        const priceAnswer = this.answerByQuestionName('question_price')
        const modelAnswer = this.answerByQuestionName('question_model')
        const priceAnswerValue = priceAnswer && priceAnswer.value ? priceAnswer.value : priceAnswer
        const imageUrl = (side, color, idParts) => `/api/product-image/?side=${side}${color && color.value ? `&color=${color.value}` : ''}&${idParts.map(el => `el[]=${el}`).join('&')}&modelCategory=${modelAnswer.name}`
        const preparedItems = combinedItems
          .filter(c => c['Top'] && (c['Skirt'] || c['Pants']))
          .map(item => {
            const nameParts = {}
            const idParts = []
            const images = []
            const thumbs = []
            const skuParts = []
            let price = 0
            const backImages = []
            const moods = Object.values(item).reduce((moods, element) => {
              if (element['Please select your inspiration mood board:']) {
                element['Please select your inspiration mood board:'].forEach(mood => {
                  if (!moods.includes(mood)) {
                    moods.push(mood)
                  }
                })
              }
              return moods
            }, [])
            Object.keys(item)
              .sort((a, b) => {
                return this.flatLayerOrder.indexOf(a) - this.flatLayerOrder.indexOf(b)
              })
              .forEach(layer => {
                if (item[layer]) {
                  nameParts[layer] = item[layer]['Element Name']
                  if (item[layer].airtableId) idParts.push(item[layer].airtableId)
                  if (item[layer].SKU) {
                    skuParts.push(layer.slice(0, 2) + item[layer].SKU)
                  }
                  const colorable = item[layer].Colorable && item[layer].Colorable.toLowerCase().includes('yes')
                  if (item[layer].Price && item[layer].Price.length) {
                    const priceString = item[layer].Price.find(p => p.startsWith(priceAnswerValue))
                    if (priceString && priceString.includes(':')) {
                      const priceParts = priceString.split(/:\s?\$/)
                      if (priceParts && priceParts[1]) {
                        price += +priceParts[1].replace(',', '.').replace(/[^\d.]/, '')
                      }
                    }
                  }
                  if (item[layer]['Price Extra'] && +item[layer]['Price Extra'] > 0) {
                    price += +item[layer]['Price Extra']
                  }
                  if (item[layer].Image && item[layer].Image[0]) {
                    if (item[layer]['Back image'] && item[layer]['Back image'].length) {
                      backImages.push({
                        colorable,
                        layer,
                        name: item[layer]['Back image'][0].filename,
                        url: item[layer]['Back image'][0].url
                      })
                    }
                    images.push({
                      colorable,
                      layer,
                      name: item[layer].Image[0].filename,
                      url: item[layer].Image[0].url
                    })
                    if (item[layer].Image[0] && item[layer].Image[0].thumbnails && item[layer].Image[0].thumbnails.large) {
                      thumbs.push({
                        colorable,
                        layer,
                        name: item[layer].Image[0].thumbnails.large.filename,
                        url: item[layer].Image[0].thumbnails.large.url
                      })
                    }
                  }
                }
              })
            return {
              id: `BG:${priceAnswerValue};;EL:${idParts.join(',')};;MD:${modelAnswer.name}`,
              name: this.formatElementName(nameParts),
              model: modelAnswer,
              images,
              backImages,
              origin: item,
              moods,
              thumbs,
              price,
              front: imageUrl('front', null, idParts),
              back: imageUrl('back', null, idParts),
              sku: skuParts.join('')
            }
          })
        if (this.paintColors && this.paintColors.length && this.firstQuestionAnswer !== 'Design wedding gowns') {
          return this.paintColors.filter(color => color && color.color).reduce((items, color) => {
            const colorName = nameHexColor(color)
            preparedItems.forEach(item => {
              const fitsMainColors = Object.keys(item.origin).reduce((fits, key) => {
                const part = item.origin[key]
                return fits && (!part['Main color'] || !part['Main color'].length || part['Main color'].includes(color.value))
              }, true)
              if (fitsMainColors) {
                items.push({
                  ...item,
                  id: item.id + `;;CL:${color.value}`,
                  colorName,
                  front: `${item.front}&color=${color.value}`,
                  back: `${item.back}&color=${color.value}`,
                  oldName: item.name,
                  name: colorName + ' ' + item.name,
                  paintColor: color
                })
              }
            })
            return items
          }, []).map(item => ({...item, id: encodeSKU(item.id)})).sort(() => Math.random() - 0.5)
        } else {
          return preparedItems.map(item => ({...item, id: encodeSKU(item.id)})).sort(() => Math.random() - 0.5)
        }
      }
      return []
    },
    moods () {
      return this.variants.reduce((moods, variant) => {
        Object.values(variant.origin).forEach(element => {
          if (element['Please select your inspiration mood board:']) {
            element['Please select your inspiration mood board:'].forEach(mood => {
              if (!moods.includes(mood)) {
                moods.push(mood)
              }
            })
          }
        })
        return moods
      }, [])
    },
    variantsByMood () {
      return this.moods.map(mood => ({
        mood,
        variants: this.variants.filter(v => v.moods.includes(mood))
      }))
    }
  },
  methods: {
    ...mapMutations('questionnaire', ['setSelectedOffer']),
    handleAddToCart (item) {
      this.$store.dispatch('cart/add', { item, price: 1000 })
    },
    formatElementName (parts) {
      let template = '{Top}, {Sleeve} with {Skirt}{Pants} and {Embroidery} and {Belt}'
      Object.keys(parts).forEach(key => {
        template = template.replace(`{${key}}`, `${parts[key]}`.trim())
      })
      return template
        .replace(/\{[^}]+\}/g, '')
        .replace(/\s?and\s?$/, '')
        .replace(/\s?and\s?$/, '')
        .replace(/\s?with\s?$/, '')
        .replace('and  and', 'and').trim()
    },
    handleRestart () {
      this.$store.commit('questionnaire/newQuestionnaire')
      this.$router.push('/questionnaire')
    },
    handleBack () {
      this.$store.commit('questionnaire/setPrevious')
      this.$router.push('/questionnaire')
    },
    handleSelect (offer) {
      this.setSelectedOffer(offer)
      this.$router.push('/questionnaire/detailed')
    },
    handlePageClick (page) {
      this.currentPage = page
    },
    getNextLayer (usedLayers) {
      const leftLayers = this.layerOrder.filter(l => {
        if (Array.isArray(l)) {
          return !l.some(il => usedLayers.includes(il))
        }
        return !usedLayers.includes(l)
      })
      const matchingLayer = leftLayers.find(l => {
        if (Array.isArray(l)) {
          return Object.keys(this.fittingItems).find(cl => l.includes(cl))
        }
        return Object.keys(this.fittingItems).includes(l)
      })
      if (matchingLayer) {
        if (!Array.isArray(matchingLayer)) {
          return [matchingLayer]
        }
        return matchingLayer
      }
      return null
    },
    combineItems (usedLayers, combinations) {
      let currentLayerCombinations = []
      const layers = this.getNextLayer(usedLayers)
      if (layers && layers.length) {
        combinations.forEach(combination => {
          layers.forEach(layer => {
            if (!layer) {
              if (Object.keys(combination).length) {
                currentLayerCombinations.push(combination)
              }
            } else {
              if (this.checkLayerCompatibility(combination, layer)) {
                const layerItems = this.fittingItems[layer]
                if (layerItems) {
                  layerItems.forEach(layerItem => {
                    if (this.checkLayerItemCompatibility(combination, layer, layerItem)) {
                      currentLayerCombinations.push({
                        ...combination,
                        moods: this.getCombinationMoods(combination, layerItem),
                        colors: this.getCombinationColors(combination, layerItem),
                        [layer]: layerItem
                      })
                    }
                  })
                }
              } else {
                if (Object.keys(combination).length) {
                  currentLayerCombinations.push(combination)
                }
              }
            }
          })
        })
        return this.combineItems([...usedLayers, ...layers], currentLayerCombinations)
      } else {
        return combinations
      }
    },
    checkLayerCompatibility (combination, layer) {
      const sleeveAddonTypes = Object.values(combination)
        .filter(c => c['Sleeve Add On'])
        .map(c => c['Sleeve Add On'].split(/:\s+?/))
        .filter(a => a && a[1])
        .map(a => a[1].toLowerCase())

      if (layer === 'Sleeve' && sleeveAddonTypes.includes('no')) {
        return false
      }
      if (layer === 'Embroidery' && combination['Belt']) {
        return false
      }
      if (layer === 'Belt' && combination['Embroidery']) {
        return false
      }
      return true
    },
    checkLayerItemCompatibility (combination, layer, layerItem) {
      return this.isItemMoodCompatible(combination, layerItem, layer) &&
        this.isItemColorCompatible(combination, layerItem, layer) &&
          this.isItemWaistCompatible(combination, layerItem, layer)
    },
    isItemColorCompatible (combination, layerItem, layer) {
      const FIELD_CODE = 'Please select your favorite colors:'
      const layerItemColors = layerItem[FIELD_CODE]
      if (layerItemColors && layerItemColors.join().toLowerCase() === 'any') {
        return true
      } else {
        // let allCombinationColors = []
        const colors = Object.values(combination).reduce((colors, element) => {
          if (element[FIELD_CODE] && element[FIELD_CODE].length) {
            const elementColors = element[FIELD_CODE]
            if (elementColors && elementColors.join().toLowerCase() === 'any') return colors
            return colors && colors.length ? colors.filter(o => elementColors && elementColors.includes(o)) : elementColors
          }
          return colors
        }, [])
        const colorsIntersection = colors && colors.length ? colors.filter(o => layerItemColors && layerItemColors.includes(o)) : layerItemColors
        // if (layer === 'Embroidery' && colorsIntersection && colorsIntersection.length) {
        //   console.log(layerItem[FIELD_CODE].join(', '), colorsIntersection, allCombinationColors, colors, combination)
        // }
        // if (!hasColorIntersection) {
        //   console.log(`Failed to combine ${layer} by color`, colors.join(', '), 'with', layerItem['Please select your favorite colors:'].join(', '), combination)
        // }
        return colorsIntersection && colorsIntersection.length
      }
    },
    isItemMoodCompatible (combination, layerItem, layer) {
      const FIELD_CODE = 'Please select your inspiration mood board:'
      const layerItemMoods = layerItem[FIELD_CODE]
      if (layerItemMoods && layerItemMoods.join().toLowerCase() === 'any') {
        return true
      } else {
        const moods = Object.values(combination).reduce((moods, element) => {
          if (element[FIELD_CODE] && element[FIELD_CODE].length) {
            const elementMoods = element[FIELD_CODE]
            if (elementMoods && elementMoods.join().toLowerCase() === 'any') return moods
            return moods && moods.length ? moods.filter(o => elementMoods && elementMoods.includes(o)) : elementMoods
          }
          return moods
        }, [])
        const moodsIntersection = moods && moods.length ? moods.filter(o => layerItemMoods && layerItemMoods.includes(o)) : layerItemMoods
        // if (!hasMoodIntersection) {
        //   console.log(`Failed to combine ${layer} by mood`, moods.join(', '), 'with', layerItem['Please select your inspiration mood board:'].join(', '), combination)
        // }
        return moodsIntersection && moodsIntersection.length
      }
    },
    isItemWaistCompatible (combination, layerItem, layer) {
      const FIELD_CODE = 'Waist'
      const layerItemWaists = layerItem[FIELD_CODE]
      if (layerItemWaists && layerItemWaists.join().toLowerCase() === 'any') {
        return true
      } else {
        const waists = Object.values(combination).reduce((waists, element) => {
          if (element[FIELD_CODE] && element[FIELD_CODE].length) {
            const elementWaists = element[FIELD_CODE]
            if (elementWaists && elementWaists.join().toLowerCase() === 'any') return waists
            return waists && waists.length ? waists.filter(o => elementWaists && elementWaists.includes(o)) : elementWaists
          }
          return waists
        }, [])
        const waistsIntersection = waists && waists.length ? waists.filter(o => layerItemWaists && layerItemWaists.includes(o)) : layerItemWaists
        // if (!hasWaistIntersection) {
        //   console.log(`Failed to combine ${layer} by waist`, waists.join(', '), 'with', layerItem['Please select your inspiration waist board:'].join(', '), combination)
        // }
        return waistsIntersection && waistsIntersection.length
      }
    },
    getCombinationMoods (combination, layerItem) {
      const FIELD_CODE = 'Please select your inspiration mood board:'
      const moods = combination.moods || Object.values(combination).reduce((moods, element) => {
        if (element[FIELD_CODE]) {
          element[FIELD_CODE].forEach(mood => {
            if (!moods.includes(mood)) {
              moods.push(mood)
            }
          })
        }
        return moods
      }, [])
      const layerItemMoods = layerItem[FIELD_CODE]
      return moods.filter(o => layerItemMoods && layerItemMoods.includes(o))
    },
    getCombinationColors (combination, layerItem) {
      const FIELD_CODE = 'Please select your favorite colors:'
      const colors = combination.colors || Object.values(combination).reduce((colors, element) => {
        if (element[FIELD_CODE]) {
          element[FIELD_CODE].forEach(color => {
            if (!colors.includes(color)) {
              colors.push(color)
            }
          })
        }
        return colors
      }, [])
      const layerItemColors = layerItem[FIELD_CODE]
      return colors.filter(o => layerItemColors && layerItemColors.includes(o))
    }
  }
}
</script>
<style lang="scss" scoped>
  .pl20 {
    @include smaller-than(tablet) {
      padding-left: 0px;
    }
  }
  .links {
    width: 100%;
    padding: 0 8px;
    box-sizing: border-box;
    display: grid;
    grid-template-areas: 'a b';
    align-items: center;
    align-content: center;
    justify-content: space-between;
  }
  .semi-link, .restart-link  {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .semi-link {
    grid-area: a;
  }
  .restart-link {
    grid-area: b;
    text-align: right;
  }
  .questionnaire-pay {
    border-radius: 3px;
    color: color(primary, $colors-background);
    background-color: color(accent, $colors-theme, hover);
    padding: 10px 30px;
    border: none;
    &[disabled] {
      background-color: color(tertiary, $colors-theme);
      cursor: not-allowed;
    }
    &__wrapper {
      width: 100%;
      text-align: center;
    }
  }
</style>
